import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function WhyUs() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // sekali animasi saja
  }, []);
  
  return (
    <section className="whyus-section" id="why-us">
      <h1 className="text-center whyus-title" data-aos="fade-up">
        <span style={{ color: '#FFD54F' }}>Why</span>{" "}
        <span style={{ color: '#1F2937' }}>Choose Us?</span>
      </h1>

      <p className="text-center whyus-subtitle" data-aos="fade-up" data-aos-delay="100">
      </p>

      <hr className="whyus-hr" data-aos="zoom-in" data-aos-delay="200" />

      {/* First Row */}
      <div className="row align-items-center whyus-row">
        <div className="col-12 col-md-6 p-4" data-aos="fade-right">
          <h3 className="whyus-heading">Brand Growth and Connection</h3>
          <p className="whyus-paragraph">

          We understand how a brand can grow, adapt, and build connections with its audience. At EDC, we focus on creating strategies that not only elevate your brand’s presence but also ensure a lasting relationship with your target market.
          </p>
        </div>
        <div className="col-12 col-md-6 p-4 text-center" data-aos="fade-left">
          <img className="img-fluid" src="/assets/human3.png" alt="EDC" />
        </div>
      </div>
      {/* Second Row */}
      <div className="row align-items-center flex-row-reverse whyus-row">
        <div className="col-12 col-md-6 p-4" data-aos="fade-left">
          <h3 className="whyus-heading">Data-Driven Strategies</h3>
          <p className="whyus-paragraph">
          The strategies we create are always based on data and market trends. By analyzing consumer behavior, competitor performance, and market shifts, we craft strategies that are not only timely but also impactful for your brand’s growth.
          </p>
        </div>
        <div className="col-12 col-md-6 p-4 text-center" data-aos="fade-right">
          <img className="img-fluid" src="/assets/human4.png" alt="What We Do" />
        </div>
      </div>
      <div className="row align-items-center whyus-row">
        <div className="col-12 col-md-6 p-4" data-aos="fade-right">
          <h3 className="whyus-heading">Extensive Network</h3>
          <p className="whyus-paragraph">

Our extensive network, from KOLs to content creators, is ready to help your brand stand out and gain wider recognition. With access to influential voices across various platforms, we ensure your brand reaches the right audience, in the right way.
          </p>
        </div>
        <div className="col-12 col-md-6 p-4 text-center" data-aos="fade-left">
          <img className="img-fluid" src="/assets/human5.png" alt="EDC" />
        </div>
      </div>

      <div className="row align-items-center flex-row-reverse whyus-row">
        <div className="col-12 col-md-6 p-4" data-aos="fade-left">
          <h3 className="whyus-heading">Creating Relevant Ideas</h3>
          <p className="whyus-paragraph">
Not just following trends, we create creative ideas that are relevant to your business goals. Our approach goes beyond surface-level trends – we design strategies that align with your brand’s core mission and deliver long-term results.
</p>
        </div>
        <div className="col-12 col-md-6 p-4 text-center" data-aos="fade-right">
          <img className="img-fluid" src="/assets/human2.png" alt="What We Do" />
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
